/* eslint-disable max-len */
import React from 'react';
import { CreatePromotionStepProps } from 'domains/promotion/Promotion.types';
import DatesSection from 'pages/BackOfficePage/BackOfficeCategories/Promotion/CreatePromotion/PromotionDetailsStep/DatesSection';
import { DescriptionSection } from 'pages/BackOfficePage/BackOfficeCategories/Promotion/CreatePromotion/PromotionDetailsStep/DescriptionSection';
import { TargetSection } from 'pages/BackOfficePage/BackOfficeCategories/Promotion/CreatePromotion/PromotionDetailsStep/TargetSection';
import { Flex } from 'UI';
import { useResetScroll } from 'utils/hooks/useResetScroll';

const PromotionDetailsStep = ({ promotion, setPromotion }: CreatePromotionStepProps) => {
  useResetScroll();
  return (
    <Flex direction={'column'} size={0} data-cy={'promotion-details-step-page'}>
      <DescriptionSection promotion={promotion} setPromotion={setPromotion} data-cy={'description-section'} />
      <TargetSection promotion={promotion} setPromotion={setPromotion} data-cy={'target-audience-section'} />
      <DatesSection promotion={promotion} setPromotion={setPromotion} data-cy={'publication-dates-section'} />
    </Flex>
  );
};

export default PromotionDetailsStep;
